import React, { FC } from "react";
import { getImageUrl } from "src/utils/getImageUrl";
import { Avatar } from "src/components/Avatar";
import { Sizes } from "src/@types/sizes";
import { IUserProfileCard } from "src/@types/users";
import { MetricItem } from "./MetricItem";

interface Props extends IUserProfileCard {}

export const ProfileCard: FC<Props> = ({ metrics, host, name }) => {
  const { location, avatarUrl } = host || {};

  return (
    <div className="flex flex-col gap-5 p-5 border border-x-black-base/20 rounded-20">
      <div className="flex justify-center items-center gap-5 font-medium">
        <Avatar
          sizeVariant={Sizes.M}
          avatarUrl={getImageUrl(avatarUrl)}
          altText="avatar"
        />

        <div className="text-purple-base text-lg">
          <h4 className="text-purple-base text-nowrap">{name}</h4>
          <div className="flex items-center gap-2">
            <span>
              {location?.city ? location?.city : location?.country?.title}
            </span>

            <img
              className="w-6.5 aspect-square object-cover rounded-full"
              src={getImageUrl(location?.country?.icon)}
              alt={location?.country?.slug}
              title={location?.country?.title}
            />
          </div>
        </div>
      </div>

      {/* CHANGE - metrics will be made optional and conditional rendering will be implemented here  */}
      <div className="flex justify-center items-center">
        {Boolean(metrics?.length) &&
          metrics.map((metric) => (
            <MetricItem key={metric.title} {...metric} />
          ))}
      </div>
    </div>
  );
};
